import UserLogin from "@/components/shared/header/login/UserLogin";
import useUser from "@/api/apis";
import AccountIcon from "@/v2-components/core/icon/account-icon";
import React from "react";
import { AuthUtils } from "@/utils/AuthUtils";
import { useRouter } from "next/router";
import SpinIcon from "@/assets/icons/SpinIcon";
import { Button } from "@/v2-components/ui/button";

/*
 user login container
 */

const Loading = () => (
  <div className="absolute inset-0 flex animate-spin items-center justify-center rounded-full">
    <SpinIcon className="text-coolgray-60" />
  </div>
);

export const UserLoginContainer = () => {
  const { user, isLoading } = useUser();
  const router = useRouter();

  const login = () => {
    const loginUrl = AuthUtils.getLoginUrl();
    router.push(loginUrl);
  };

  if (!user)
    return (
      <Button
        variant="darkgray-text"
        size="none"
        className="relative min-h-6 min-w-6 p-0 hover:text-coolgray-60"
        onClick={login}
      >
        <AccountIcon />
      </Button>
    );

  return <UserLogin user={user} />;
};
